import PositionTable from "@/components/PositionTable";

export default function Positions() {
  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 20 }}>
        Positions
      </h1>
      <div className="card">
        <PositionTable />
      </div>
    </div>
  );
}
